import { v4 as uuidv4 } from 'uuid';
import { ReportFilter } from '../Shared/ReportFilter';
import { ReportFilterCreator } from '../Components/ReportFilter/ReportFilterCreator';

interface IReportListCreator {
    reportName: string
    asmName: string
    userId: string
    visibleFilters: ReportFilter[]
    cancel: () => void
    process: () => void
}

export const ReportListCreatorTab = (data: IReportListCreator): ITab => {
    return {
        id: uuidv4(),
        title: `Параметры отчёта:${data.reportName}`,
        view: {
            content: <ReportFilterCreator
                filters={data.visibleFilters}
                asmName={data.asmName}
                userId={data.userId}
                visibleFilters={data.visibleFilters}
                cancel={() => data.cancel()}
                process={() => data.process()}
            />
        }
    }
}
